import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';

function readInitialEsimCatalogue() {
  const element = document.getElementById('__ESIM_CATALOGUE__');
  if (!element?.textContent) return null;
  try {
    const catalogue = JSON.parse(element.textContent);
    return Array.isArray(catalogue?.countries) ? catalogue : null;
  } catch (_error) {
    return null;
  }
}

const initialEsimCatalogue = readInitialEsimCatalogue();

hydrateRoot(
  document.getElementById('root'),
  <React.StrictMode>
    <BrowserRouter>
      <App initialEsimCatalogue={initialEsimCatalogue} />
    </BrowserRouter>
  </React.StrictMode>,
);
